"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateProp = void 0;
const truncateProp = {
    type: 'boolean',
    className: 'rt-truncate',
    default: undefined,
};
exports.truncateProp = truncateProp;
//# sourceMappingURL=truncate.prop.js.map